import { Config } from '@library/utilities/interface'
import { Button, Card, Col, Drawer, Row } from 'gokwik-ui-kit'

interface Props {
    differenceData: Config[]
    handleClose: () => void
    saveDetails: () => void
}

export default function ({ differenceData, handleClose, saveDetails }: Props) {
    return (
        <>
            <Drawer
                title={'Changes'}
                open={true}
                onClose={handleClose}
                width={600}
                footer={<Footer handleBack={handleClose} saveChanges={saveDetails} />}
            >
                <Row gutter={[4, 4]} className='mt-2'>
                    {differenceData?.map((log, index) => (
                        <Col key={index} span={24}>
                            <Card
                                className='mt-2 mb-2'
                                title={
                                    <div className='text-sm flex justify-between'>
                                        <span className='font-normal'>
                                            Category: <b>{log?.categoryTitle}</b>
                                        </span>

                                        <span className='font-normal'>
                                            Sub Category: <b>{log?.subcategoryTitle}</b>
                                        </span>
                                    </div>
                                }
                            >
                                <Row gutter={[8, 8]}>
                                    <Col span={8} className='text-gray-500'>
                                        <span>Key</span>
                                    </Col>
                                    <Col span={8} className='text-gray-500'>
                                        <span>Old Value</span>
                                    </Col>
                                    <Col span={8} className='text-gray-500'>
                                        <span>New Value</span>
                                    </Col>
                                </Row>
                                <Row gutter={[8, 8]} className='mt-3'>
                                    <Col span={8}>
                                        <div className='h-full w-full flex items-center'>
                                            <strong className='break-words max-w-full text-regular pt-2'>
                                                {log.title}
                                            </strong>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className='h-full max-h-80 overflow-auto bg-blue-50 rounded p-2 border-l-4 border-red-400'>
                                            <pre className='break-words text-sm'>
                                                {JSON.stringify(log?.oldValue, null, 2)}
                                            </pre>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className='h-full max-h-80 overflow-auto bg-yellow-50 rounded p-2 border-l-4 border-green-400'>
                                            <pre className='break-words text-sm'>
                                                {JSON.stringify(log?.value, null, 2)}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Drawer>
        </>
    )
}

const Footer = ({ handleBack, saveChanges }) => {
    return (
        <Row className='bg-white m-2 rounded-md box-border'>
            <Col span={24} className='w-full flex gap-4'>
                <Button variant='default' className='w-full' onClick={handleBack}>
                    Back
                </Button>
                <Button variant='primary' className='w-full' onClick={saveChanges}>
                    Save Changes
                </Button>
            </Col>
        </Row>
    )
}
